import { Navigate } from "react-router-dom";
import { supabase } from "./supabaseClient";
import { useEffect, useState } from "react";

const PublicRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

    useEffect(() => {
      const check = async () => {
        const { data } = await supabase.auth.getSession();

        if (data.session) {
          setIsAuth(true);
        }

        setLoading(false);
      };

      check();
    }, []);

  if (loading) return <div>Loading...</div>;

  return isAuth ? <Navigate to="/profile" /> : children;
};

export default PublicRoute;